const defaultStyle = {
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
};

// Defensive renderer for fields whose exact shape isn't hand-modeled elsewhere —
// extracted from auditLog.js's ChangesModal so both pages stay consistent.
export const formatValue = (value, style = defaultStyle) => {
  let content;
  if (value === undefined) content = <span style={{ color: '#98A2B3' }}>—</span>;
  else if (value === null) content = <span style={{ color: '#98A2B3' }}>prazno</span>;
  else if (typeof value === 'boolean') content = value ? 'Da' : 'Ne';
  else if (typeof value === 'object')
    content = <code>{JSON.stringify(value, null, 2)}</code>;
  else content = String(value);
  return <div style={style}>{content}</div>;
};
